import MermaidComponent from './MermaidComponent';
import { callFlowChart } from '../config/callFlowChart';

const CallFlow = () => {
  return (
    <div className="p-6">
      <h2 className="flex justify-center text-2xl font-bold mb-4">Call Workflow</h2>
      <MermaidComponent chart={callFlowChart} />
    </div>
  );
};

export default CallFlow;
